import { render } from "./NavText.vue?vue&type=template&id=eb37ca46"
import script from "./NavText.vue?vue&type=script&lang=js"
export * from "./NavText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__